// extracted by mini-css-extract-plugin
export var active = "FooterWide-module--active--5df66";
export var activeLink = "FooterWide-module--activeLink--b1c0b";
export var aloneLink = "FooterWide-module--aloneLink--53f03";
export var bg = "FooterWide-module--bg--da33a";
export var companyLinks = "FooterWide-module--companyLinks--7b1bd";
export var credential = "FooterWide-module--credential--38d44";
export var divider = "FooterWide-module--divider--620b1";
export var end = "FooterWide-module--end--b8184";
export var footer = "FooterWide-module--footer--bd495";
export var footerMain = "FooterWide-module--footerMain--27812";
export var link = "FooterWide-module--link--149d0";
export var linkWrapper = "FooterWide-module--linkWrapper--837d5";
export var martian = "FooterWide-module--martian--06593";
export var socials = "FooterWide-module--socials--c0762";
export var wrapper = "FooterWide-module--wrapper--cf7b4";
export var wrapperMain = "FooterWide-module--wrapperMain--9afe2";